exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".PieVcDemo h4[data-v-7999d3c4]{color:#066}.PieVcDemo .demoItem[data-v-7999d3c4]{padding:10px 0;font-size:18px;border-bottom:1px dotted #999}", ""]);

// exports
